var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7793 2.56381C45.2589 0.0431821 41.1725 0.0431815 38.6521 2.56381L25.1737 16.0433L11.6954 2.56381C9.17494 0.0431823 5.08854 0.0431821 2.56812 2.56381C0.0477006 5.08445 0.0477009 9.1712 2.56812 11.6918L16.0465 25.1713L2.56414 38.6548C0.0437236 41.1755 0.0437236 45.2622 2.56414 47.7829C5.08456 50.3035 9.17097 50.3035 11.6914 47.7829L25.1737 34.2994L38.6561 47.7829C41.1765 50.3035 45.2629 50.3035 47.7833 47.7829C50.3038 45.2622 50.3038 41.1755 47.7833 38.6548L34.301 25.1713L47.7793 11.6918C50.2998 9.1712 50.2998 5.08445 47.7793 2.56381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalse);
export default __webpack_public_path__ + "static/media/False.5eb5ff954446b51889a7353b5d3cf842.svg";
export { ForwardRef as ReactComponent };